import { NgModule } from '@angular/core';
import { HostedPaymentRoutingModule } from 'features/hosted-payment/hosted-payment-routing.module';
import { ConfigModule } from './config/config.module';
@NgModule({
  imports: [
    HostedPaymentRoutingModule,
    ConfigModule
  ]
})
export class HostedPaymentModule { }
